var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { staticClass: "actions", attrs: { x: "", y: false, tag: "w-row" } },
    [
      _vm.state.showViewSelect()
        ? _c("app-select-view", { attrs: { state: _vm.state } })
        : _vm._e(),
      _c(
        "w-button-bar",
        { style: { flexShrink: 0 } },
        [
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.isFetching },
              on: {
                click: function ($event) {
                  return _vm.refresh()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "sync", spin: _vm.isFetching } })],
            1
          ),
        ],
        1
      ),
      !_vm.$wf.isMdDown
        ? _c("app-quick-search", {
            attrs: { state: _vm.state },
            on: {
              enter: function ($event) {
                return _vm.startSearch($event)
              },
            },
          })
        : _vm._e(),
      _c("w-spacer"),
      _vm.itemsSelected && _vm.showSelectedItemsCount
        ? _c(
            "app-tag",
            {
              staticClass: "mr action",
              attrs: { icon: "times" },
              on: {
                click: function ($event) {
                  return _vm.emptySelectedItems()
                },
              },
            },
            [
              !_vm.$wf.isLgDown
                ? [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$ctc("selected", _vm.selectedItems.length, {
                            amount: _vm.selectedItems.length,
                          })
                        ) +
                        " "
                    ),
                  ]
                : [_vm._v(" " + _vm._s(_vm.selectedItems.length) + " ")],
            ],
            2
          )
        : _vm._e(),
      _vm.state.querySettings.searchQuery
        ? _c(
            "app-tag",
            {
              staticClass: "mr action search-chip",
              attrs: { icon: "times" },
              on: {
                click: function ($event) {
                  return _vm.clearSearchQuery()
                },
              },
            },
            [
              !_vm.$wf.isMdDown
                ? [
                    _c("span", { staticClass: "search-chip-content" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct("cancelSearch", [
                              _vm.state.querySettings.searchQuery,
                            ])
                          ) +
                          " "
                      ),
                    ]),
                  ]
                : [
                    _c("w-fa", { attrs: { icon: "search" } }),
                    _vm._v('" '),
                    _c("span", { staticClass: "search-chip-content" }, [
                      _vm._v(
                        " " + _vm._s(_vm.state.querySettings.searchQuery) + " "
                      ),
                    ]),
                    _vm._v(' " '),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm.state.querySettings.filters.length &&
      !_vm.state.querySettings.searchQuery
        ? _c(
            "app-tag",
            {
              staticClass: "light mr tag action",
              attrs: { icon: "times" },
              on: {
                click: function ($event) {
                  return _vm.clearFilters()
                },
              },
            },
            [
              !_vm.$wf.isMdDown
                ? [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$ct("cancelFilters", [
                            _vm.state.querySettings.filters.length,
                          ])
                        ) +
                        " "
                    ),
                  ]
                : [
                    _c("w-fa", { attrs: { icon: "search" } }),
                    _vm._v(
                      " " + _vm._s(_vm.state.querySettings.filters.length) + " "
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm.state.allowViewButton
        ? _c(
            "w-button-bar",
            { staticClass: "mr", style: { flexShrink: 0 } },
            [
              _vm.dataSource.info
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("tooltip.info"),
                          expression: "$ct('tooltip.info')",
                        },
                      ],
                      attrs: { disabled: !_vm.canView },
                      on: {
                        click: function ($event) {
                          return _vm.infoClicked()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "eye" } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-button-bar",
        { style: { flexShrink: 0 } },
        [
          _vm._t("extra-buttons"),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.search"),
                  expression: "$ct('common.search')",
                },
              ],
              on: {
                click: function ($event) {
                  _vm.state.showSearch = true
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "search" } })],
            1
          ),
          !_vm.$wf.isMdDown
            ? _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("print-browse"),
                      expression: "$ct('print-browse')",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.state.browseToFileModalOpen = true
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "print" } })],
                1
              )
            : _vm._e(),
          _vm.state.showReportsButton
            ? _c("app-reports-dropdown", {
                attrs: { state: _vm.state, "with-printing-button": true },
              })
            : _vm._e(),
          _vm.buttonBarItems != undefined
            ? _c(
                "w-dropdown",
                {
                  attrs: {
                    items: _vm.buttonBarItems,
                    disabled:
                      _vm.buttonBarItems && _vm.buttonBarItems.length == 0,
                    right: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.trigger($event)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "bars" } })],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._t("browse-action-buttons"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }